<!--
 * @Author: ZS
 * @Date: 2020-06-23 11:46:25
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-17 17:34:14
 * @Description: file content
-->
<!--
 * @Author: ZS
 * @Date: 2020-06-18 16:24:41
 * @LastEditors: ZS
 * @LastEditTime: 2020-06-23 10:01:30
 * @Description: file content
-->
<template>
  <div class="myBusiness">
    <h3 class="myTit clearfix">
      <span>咨询回复</span>
      <ul class="clearfix noselect">
        <li :class="{active:titIndex === 0}" @click="titChange(0)">未回复</li>
        <li :class="{active:titIndex === 1}" @click="titChange(1)">已回复</li>
      </ul>
    </h3>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="xuhao" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column label="事项名称" prop="sxmc">
        <template slot-scope="scope">
          <span>{{scope.row.sxmc}}</span>
          <div class="newBg" v-if="scope.row.hasNew">新动态</div>
        </template>
      </el-table-column>
      <el-table-column prop="pcHandlingGuidelineConsultationContent" label="咨询问题" align="center">
      </el-table-column>
      <el-table-column prop="pcHandlingGuidelineConsultationTime" label="发起时间" width="160" align="center">
      </el-table-column>
      <el-table-column prop="statu" label="回复状态" width="80" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" class="detailBtn">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block fenyeBox">
      <el-pagination @size-change="handleSizeChange0" @current-change="handleCurrentChange0"
        :current-page="fenye.currentPage0" :page-sizes="[10, 20, 30, 40]" :page-size="fenye.pageSize0"
        layout="total, sizes, prev, pager, next, jumper" :total="fenye.totalNum0" v-if="titIndex == 0">
      </el-pagination>
      <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
        :current-page="fenye.currentPage1" :page-sizes="[10, 20, 30, 40]" :page-size="fenye.pageSize1"
        layout="total, sizes, prev, pager, next, jumper" :total="fenye.totalNum1" v-if="titIndex == 1">
      </el-pagination>
    </div>
    <!-- 详情对话框 -->
    <el-dialog title="咨询详情" :visible.sync="dialogVisible" width="550px" class="dialog">
     <h3 class="sxName">咨询事项：{{sxName}}</h3>
      <div class="que clearfix">
        <span><img src="../../../assets/images/que.png" style="margin-right:8px">{{que}}</span>
        <p class="clearfix"><span class="pull-left">咨询人：{{zxr}}</span> <span class="pull-right">{{queTime}}</span></p>
      </div>
      <div class="ans clearfix">
        <span>回复：<el-input type="textarea" :rows="6"  placeholder="请输入内容" v-model="ans"
            style="display:line-block;width: 87%; vertical-align: text-top;">
          </el-input></span>
        <p>{{ansTime}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()" class="tjBtn" v-if="titIndex == 0">提交回复</el-button>
        <el-button @click="handleClose()" class="tjBtn" v-if="titIndex == 1">更新答案</el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        tableData: [],
        fenye: {
        currentPage0: 1,
        pageSize0: 10,
        totalNum0: 0,
        currentPage1: 1,
        pageSize1: 10,
        totalNum1: 0,
        },
        titIndex: 0,
        sfhf: 0,
        totalNum: 0,
        dialogVisible: false,
        que: '',
        queTime: '',
        ans: '',
        ansTime: '',
        zxr: '',
        id: '',
        code: '',
        sxName:''
      }
    },
    mounted() {
      this.getZx()

    },
    methods: {
      handleEdit(index, row) {
        this.ans = "";
        if (this.sfhf != 0) {
          this.ans = row.portalPcHandlingGuidelineConsultationReply[0].pcHandlingGuidelineConsultationReplyContent
          this.ansTime = this.globalDateFormat({
            time: row.portalPcHandlingGuidelineConsultationReply[0].pcHandlingGuidelineConsultationReplyTime,
            format: "yyyy-MM-dd hh:mm:ss"
          });
        }
        this.que = row.pcHandlingGuidelineConsultationContent
        this.queTime = row.pcHandlingGuidelineConsultationTime
        this.zxr = row.zxr
        this.dialogVisible = true
        this.id = row.pcHandlingGuidelineConsultationId
        this.code = row.pcHandlingGuidelineConsultationGuidelineCode
        this.sxName = row.sxmc
      },
       handleSizeChange0(val) {
       this.fenye.pageSize0 = val
       // console.log(`每页 ${val} 条`);
       this.getZx()
       },
       handleCurrentChange0(val) {
       this.fenye.currentPage0 = val
       // console.log(`当前页: ${val}`);
       this.getZx()
       },
       handleSizeChange1(val) {
       this.fenye.pageSize1 = val
       // console.log(`每页 ${val} 条`);
       this.getZx()
       },
       handleCurrentChange1(val) {
       this.fenye.currentPage1 = val
       // console.log(`当前页: ${val}`);
       this.getZx()
       },
      titChange(idx) {
        this.titIndex = idx
        this.sfhf = idx
        this.ans = ''
        this.getZx()
      },
      // 获取我的咨询
      getZx() {
         let sendData
         if (this.titIndex == 0) {
         sendData = qs.stringify({
         pageNum: this.fenye.currentPage0,
         pageSize: this.fenye.pageSize0,
         type: this.sfhf,
         })
         } else if (this.titIndex == 1) {
         sendData = qs.stringify({
         pageNum: this.fenye.currentPage1,
         pageSize: this.fenye.pageSize1,
         type: this.sfhf,
         })
         }
        this.ywtbRequest('/portal-ywtb/web/consultation/findListConsultationByCondition', sendData).then(res => {
          var data = res.dataList
           if (this.titIndex == 0) {
           this.fenye.totalNum0 = res.count
            try {
              this.$parent.changeGztBadge(5, res.count);
            } catch (error) {
              // 无需处理
            }
           } else if (this.titIndex == 1) {
           this.fenye.totalNum1 = res.count
           }
          for (let i = 0; i < data.length; i++) {
            data[i].xuhao = i+1;
            data[i].pcHandlingGuidelineConsultationTime = this.publicJs.renderTime(data[i].pcHandlingGuidelineConsultationTime);
            if (this.sfhf == 0) {
              data[i].statu = '未回复'
            } else {
              data[i].statu = '已回复'
            }
            if (data[i].pc_handling_guideline_consultation_checker == 0) {
              data[i].hasNew = true
            }

          }
          this.tableData = res.dataList;
        })
      },
      //更改提交回复
      handleClose() {
        if ([undefined, null, ""].indexOf(this.ans) > -1 || (this.ans.trim && this.ans.trim() === "")) {
          this.$message({
            type: "warning",
            message: "回复内容不能为空"
          });
          return;
        }
        let sendData = qs.stringify({
          pcHandlingGuidelineConsultationReplyConsultationId: this.id,
          pcHandlingGuidelineConsultationReplyGuidelineCode: this.code,
          pcHandlingGuidelineConsultationReplyMemberId: this.$store.state.userId,
          pcHandlingGuidelineConsultationReplyContent: this.ans
        })
        this.ywtbRequest('/portal-ywtb/web/consultation/saveConsultationByCondition', sendData).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.getZx();
        })
      }
    }
  }

</script>

<style scoped>
  .myTit {
    /* line-height: 42px; */
    padding: 30px 0 15px 0;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .myTit>span {
    float: left;
    color: #091B28;
    font-size: 22px;
    font-family: PingFang SC;
  }

  .myTit>ul {
    float: right;
  }

  .myTit>ul>li {
    float: left;
    width: 84px;
    height: 34px;
    background: rgba(53, 139, 247, 0.1);
    color: #687986;
    line-height: 34px;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    cursor: pointer;
  }

  .myTit>ul>li.active {
    background-color: #358BF7;
    color: #fff;
  }

  .detailBtn,
  .advisoryBtn {
    width: 56px;
    height: 27px;
    border-radius: 14px;
    padding: 0;
    text-align: center;
    font-size: 13px;
    color: #fff;
    border: none;
  }

  .detailBtn {
    background: rgba(255, 165, 71, 1);

  }

  .detailBtn:hover, .detailBtn:focus {
    background: rgba(255, 165, 71, 0.8);
    color: #fff;
  }

  .advisoryBtn {
    background: rgba(53, 139, 247, 1);
  }

  .advisoryBtn:hover, .advisoryBtn:focus {
    background: rgba(53, 139, 247, 0.8);
    color: #fff;
  }

  .fenyeBox {
    text-align: center;
    padding-top: 20px;
  }

  .newBg {
    display: inline-block;
    width: 55px;
    height: 23px;
    line-height: 22px;
    background: url(../../../../static/images/newBg.png) no-repeat 0px 0px;
    text-align: center;
    color: #fff;
    margin-left: 6px;
  }

  .que,
  .ans {
    font-size: 16px;
    font-weight: 700;
    margin-top: 20px;
  }

  .que>p,
  .ans>p {
    text-align: right;
    padding-right: 50px;
    font-size: 14px;
    color: #999;
    font-weight: normal;
    margin-top: 10px;
  }
  .que,
  .ans {
  font-size: 16px;
  font-weight: 700;
  margin: 20px 0 20px 0;
  }

  .que>p,
  .ans>p {
  text-align: right;
  font-size: 14px;
  color: #BFBFBF;
  font-weight: normal;
  line-height: 24px;
  }
  .dialog /deep/ .el-dialog__title {
  color: #262626;
  font-size: 18px;
  font-weight: 700;
  }
  .dialog /deep/ .el-textarea__inner {
  resize: none;
  }
  .dialog /deep/ .el-dialog__body {
  padding: 20px 40px 5px 20px;
  }
  .dialog /deep/ .el-dialog__footer{
  text-align: center;
  padding: 0px 0 30px 0;
  }
  .dialog /deep/ .el-button {
  border-radius: 2px;
  }
  .dialog .tjBtn {
  background:rgba(68,110,255,1);
  color: #fff;
  border: none;
  }
  .dialog .tjBtn:hover {
  background:rgb(50, 93, 250);
  }
  .sxName {
  font-size:18px;
  font-family:Microsoft YaHei;
  font-weight:bold;
  color:#262626;
  padding-bottom: 10px;
  border-bottom: 1px solid #E8E8E8;
  }
  .replyPerson {
  color: #6A8BFF;
  font-size: 14px;
  padding-left: 6px;
  }
  .noHf {
  text-align: center;
  padding: 10px 0 20px 0;
  }
  .noHf p {
  margin-top: 10px;
  color: #BFBFBF;
  font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/user/InquiryReply.vue